import { usePageStore, useUserStore } from '@/store';
import { mapState as rootMapState } from 'pinia';
import { mapState, mapActions } from '@/store/helpers';
import './index.scss';
import signLog from '../../components/sign-log';
import util from '../../common/util';
import * as TYPES from './_store/types';
import { checkSoldHousePreview } from '@/common/utils';
import spaceMixin from '@/modules/space-mixin';
import colorMixin from '@/modules/color-mixin';

export default {
    emits: ['activeMarker', 'collectCallback', 'asyncMounted'],
    i18next: {
        ns: 'md-house'
    },
    mixins: [spaceMixin(), colorMixin()],
    props: ['houses', 'isInMap', 'maskOption'],
    data: function() {
        checkSoldHousePreview(this.result);
        return {
            showCheckbox: false, //  first remove all checkbox,  recovery requires acceptance props inside showCheckbox value ， This value depends on map model
            shouldShowGotoTop: false,
            handleScroll: this._handleScroll.bind(this),
            resultUpdated: false,
        };
    },
    computed: {
        ...rootMapState(useUserStore, {
            user: store => store.user,
            hasLoggedIn: 'hasLoggedIn'
        }),
        ...rootMapState(usePageStore, {
            isTemplate4: store => {
                return store.page && store.page.templateId === 7;
            },
            page: store => store.page || {}
        }),
        ...mapState({
            result: function(store) {
                return this.houses ? { listings: this.houses } : store.result;
            }
        }),
        isMobile() {
            return this.platform.isMobile;
        },
        wordPressSSR({ page }) {
            return page.wordPressSSR;
        },
        widget({ page }) {
            return page.widget;
        },

        showGotoTop() {
            return this.isMobile && !!this.scrollTop && this.shouldShowGotoTop;
        },
        isSold() {
            return this.result && this.result.searchType === 'sold';
        }
    },
    watch: {
        result(result) {
            this.resultUpdated = true;
            checkSoldHousePreview(result);
        }
    },
    inject: {
        scrollTop: {
            type: Function,
            default: null
        },
        topSwiperOption: {
            type: Function,
            default: null
        }
    },
    provide() {
        return {
            isInMap: this.isInMap
        };
    },
    mounted() {
        this.$emit('asyncMounted');
    },
    methods: {
        ...mapActions({
            setResult: TYPES.SET_RESULT
        }),
        onMouseEnter(id) {
            this.$emit('activeMarker', {
                id: id,
                active: 1
            });
        },
        onMouseLeave(id) {
            // this.$emit('activeMarker', {
            //     id: id,
            //     active: 0
            // });
        },
        onChecked(id) {
            this.$emit('activeMarker', {
                id: id,
                active: 2
            });
        },
        collect(item) {
            if (this.widget) {
                const replace = false;
                let url = util.setQueryField(
                    { fav: item.status },
                    item.listingDetail,
                    replace
                );
                window.open(url, '_blank');
            } else {
                return new Promise(resolve => {
                    this.collectPsRes = resolve;
                    if (!this.hasLoggedIn) {
                        signLog.register({
                            languageTextFn: {
                                registerTitle: _ =>
                                    this.isTemplate4
                                        ? this.$t(
                                            'md-house.addHomeToFavorites'
                                        ).toUpperCase()
                                        : this.$t(
                                            'md-house.addHomeToFavorites'
                                        ),
                                registerSubTitle: _ =>
                                    this.$t('md-house.getAProfessionalReal')
                            },
                            onsuccess: () => {
                                this.doCollect(item);
                            }
                        });
                    } else {
                        this.doCollect(item);
                    }
                });
            }
        },
        doCollect(data) {
            this.$EventBus.$emit('siteTrack', {
                ...data,
                trackType: 'favor-click'
            });
            return this.axiosIns
                .get('/api-site/listingCollect', {
                    params: Object.assign(
                        {
                            timestamp: new Date().getTime()
                        },
                        data
                    )
                })
                .then(() => {
                    if (this.collectPsRes) {
                        this.collectPsRes();
                        this.$emit('collectCallback');
                        this.collectPsRes = null;
                    }
                });
        },
        _handleScroll(data) {
            if (data && data.isOutOffView) {
                this.shouldShowGotoTop =
                    data.isOutOffView.invisibleOnBottom === false;
            }
        },
        handleGotoTop() {
            if (this.scrollTop) {
                this.scrollTop(true);
            }
        }
    }
};
